export default "https://cdn-static.gokick.com/assets/dbba9902646848f8f0b834a64aaa98666d1f7693/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";